import { z } from "zod";

/** localStorage key LoginPage uses to send the user back to /oauth/consent after signing in. */
const PENDING_OAUTH_AUTHORIZATION_KEY = "pendingOAuthAuthorizationId";
/** A pending consent is only resumed if the user signs in soon after (Supabase expires the request anyway). */
const PENDING_OAUTH_MAX_AGE_MS = 10 * 60 * 1000;

const ZPendingAuthorization = z.object({ id: z.string().min(1), at: z.number() });

export function savePendingAuthorization(id: string) {
  localStorage.setItem(PENDING_OAUTH_AUTHORIZATION_KEY, JSON.stringify({ id, at: Date.now() }));
}

/** Returns (and clears) the consent request interrupted by sign-in, if it is still recent. */
export function takePendingAuthorization(): string | null {
  const raw = localStorage.getItem(PENDING_OAUTH_AUTHORIZATION_KEY);
  if (!raw) return null;
  localStorage.removeItem(PENDING_OAUTH_AUTHORIZATION_KEY);
  try {
    const pending = ZPendingAuthorization.parse(JSON.parse(raw));
    return Date.now() - pending.at <= PENDING_OAUTH_MAX_AGE_MS ? pending.id : null;
  } catch {
    return null;
  }
}
